import { Box, Grid, Typography, useTheme } from "@mui/material";
import React, { CSSProperties } from "react";
import { NavLink, useLocation } from "react-router-dom";
import LogoImage from "../../../../media/images/logoDark.svg";
import ArrowTickDown from "../../../../media/images/icons/arrow-tick-down";
import { useAppSelector } from "../../../../hooks/useRedux";

interface Props {
  hasScroll: boolean;
}

export default function DesktopHeader({ hasScroll }: Props) {
  const theme = useTheme();
  const { pathname } = useLocation();

  const { loginGrids, signupGrids } = useAppSelector((state) => state.setting);

  const activeStyle: CSSProperties = {
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
    height: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    fontWeight: "bolder",
  };

  const inActiveStyle: CSSProperties = {
    height: "50px",
    display: "flex",
    gap: "8px",

    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
  };

  return (
    <Grid
      container
      sx={{
        // position: hasScroll ? "fixed" : "static",
        // backgroundColor: hasScroll ? "background.paper" : "",

        borderWidth: "1px",
        borderColor: theme.palette.textColor.light,
        borderStyle: "solid",
        direction:
          loginGrids === "compony" || signupGrids === "company" ? "ltr" : "rtl",
        px: 3,
        // py: 1,
        display: {
          xs: "none",
          md: "flex",
        },
      }}
    >
      <Grid
        xs={4}
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <nav
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            height: "100%",
          }}
        >
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"/signup"}
          >
            <span>ثبت‌نام</span>
            <ArrowTickDown
              size={16}
              color={
                pathname.includes("signup")
                  ? theme.palette.secondary.main
                  : theme.palette.textColor.main
              }
            />{" "}
          </NavLink>
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"/login"}
          >
            <span>ورود</span>
            <ArrowTickDown
              size={16}
              color={
                pathname.includes("login")
                  ? theme.palette.secondary.main
                  : theme.palette.textColor.main
              }
            />
          </NavLink>
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"/guides"}
          >
            راهنما{" "}
          </NavLink>
        </nav>
      </Grid>
      <Grid
        xs={4}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
        }}
      >
        <img width={45} src={LogoImage} alt="" />
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          کارن ترابرنت
        </Typography>
      </Grid>
      <Grid
        xs={4}
        sx={{ display: "flex", alignItems: "center", justifyContent: "end" }}
      >
        <nav
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"courses"}
          >
            آموزش ویدئویی{" "}
          </NavLink>
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"/terms"}
          >
            قوانین{" "}
          </NavLink>
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"aboutus"}
          >
            درباره ما{" "}
          </NavLink>
          <NavLink
            style={({ isActive }) => {
              return isActive ? activeStyle : inActiveStyle;
            }}
            to={"/notifs"}
          >
            اعلانات{" "}
          </NavLink>
        </nav>
      </Grid>
    </Grid>
  );
}
